import {
  IndexRouteContent,
  PathRouteContent,
  RouteNode,
} from 'router/declarative/routeNode';
import { presentationParamDeclarations } from 'router/presentation/presentationParamDeclarations';
import { AppModules } from '../../appContainer/types';

export const routes = {
  path: '/metamodel',
  title: 'Metamodel previews',
  appModule: AppModules.METAMODEL,
  children: [
    {
      path: { index: true },
      content: async (): IndexRouteContent =>
        (await import('metamodel/MetamodelList')).MetamodelList,
    },
    {
      path: '/new',
      content: async (): PathRouteContent =>
        (await import('metamodel/CreateMetamodel')).CreateMetamodel,
    },
    {
      path: '/edit',
      children: [
        {
          path: '/:entityId',
          content: async (): PathRouteContent =>
            (await import('metamodel/EditMetamodel')).EditMetamodel,
        },
      ],
    },
    {
      path: '/:entityId',
      searchParams: presentationParamDeclarations,
      content: async (): PathRouteContent =>
        (await import('metamodel/MetamodelViewContainer'))
          .MetamodelViewContainer,
    },
  ],
} as const satisfies RouteNode;

export const METAMODEL_ENTITY_ROUTE = '/metamodel/:entityId';
